import { CreditCheckStatus } from "../../../enums/credit-check-status";
import { CreditCheckStatusLabel } from "../../../models/credit-check";
import { StatusIcons } from "../../credit-check/models/StatusIcons";

export function getStatusLabel(creditCheckStatus: string): CreditCheckStatusLabel {
  if (creditCheckStatus) {
    let statusLabel: CreditCheckStatusLabel;

    switch (creditCheckStatus) {
      case CreditCheckStatus.CreditFailed:
        statusLabel = {
          displayStatus: "Credit Check Failed",
          icon: StatusIcons.Failed
        };
        break;
      case CreditCheckStatus.CreditPassed:
        statusLabel = {
          displayStatus: "Credit Check Passed",
          icon: StatusIcons.Success
        };
        break;
      case CreditCheckStatus.CreditError:
        statusLabel = {
          displayStatus: "Credit Check Error",
          icon: StatusIcons.Failed
        };
        break;
      case CreditCheckStatus.CreditInsufficientData:
        statusLabel = {
          displayStatus: "Credit Check Insufficient Data",
          icon: StatusIcons.Warning
        };
        break;
      case CreditCheckStatus.CreditPending:
        statusLabel = {
          displayStatus: "Credit Check Pending",
          icon: StatusIcons.Warning
        };
        break;
      case CreditCheckStatus.CreditUnknown:
        statusLabel = {
          displayStatus: "Credit Check Unknown Result",
          icon: StatusIcons.Warning
        };
        break;
      default:
        statusLabel = null;
    }
    return statusLabel;
  }
  return null;
}
